import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify"; // ✅ Import ToastContainer
import "react-toastify/dist/ReactToastify.css"; // ✅ Import Toastify styles
import "bootstrap/dist/css/bootstrap.min.css";
import "../css/global.css";
import "../css/index.css";
import "../css/font-awesome.min.css";
import { Link } from "react-router-dom";


const AdditionalProduct = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);

  const userId = localStorage.getItem("userId"); // Get user ID from localStorage

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await axios.get("https://api.irfanelectricals.com/api/products");
        setProducts(response.data.products.slice(0, 2)); // Take only the first 2 products
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };
    fetchProducts();
  }, []);

  const handleAddToCart = async (productId, stock) => {
    if (!userId) {
      toast.error("❌ Please log in to add products to the cart.");
      return;
    }

    if (stock === 0) {
      toast.warning("⚠️ This product is out of stock.");
      return;
    }

    setLoading(true);

    try {
      const response = await axios.post(`https://api.irfanelectricals.com/api/cart/${userId}/item`, {
        user_id: userId,
        product_id: productId,
        quantity: 1,
      });

      if (response.status === 200 || response.status === 201) {
        toast.success("✅ Product added to cart! 🛒");
      } else {
        toast.error(`❌ Failed: ${response.data.message || "Unknown error"}`);
      }
    } catch (error) {
      toast.error(`⚠️ Error: ${error.response?.data?.message || "Network error"}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="qual" className="p_3 bg_light">
      <div className="container-xl">
        <div className="row qual_1">
          <div className="col-md-7">
            <div className="qual_1l">
              <h4 className="col_blue">Additional Product</h4>
              <h1 className="mt-3">Best Quality Product</h1>

              <div className="row list_2 mt-4">
                {products.length > 0 ? (
                  products.map((product) => (
                    <div key={product.id} className="col-md-6">
                      <div className="list_2im clearfix bg-white shadow_box position-relative">
                        <div className="list_2im1 clearfix">
                          <div className="grid clearfix">
                            <figure className="effect-jazz mb-0">
                              <a href={`/product/${product.id}`}>
                                <img
                                  src={`https://api.irfanelectricals.com/uploads/${product.images[0]}`}
                                  className="w-100"
                                  alt={product.name}
                                  onError={(e) => (e.target.src = "https://via.placeholder.com/270")}
                                />
                              </a>
                            </figure>
                          </div>
                        </div>
                        <div className="list_2im2 clearfix p-3 text-center">
                          <h4>{product.name}</h4>
                          <h5>${product.price?.toFixed(2)}</h5>

                          <p className={`mt-2 ${product.stock === 0 ? "text-danger" : "text-info"}`}>
                            <strong>Lot Item:</strong> {product.stock !== undefined ? product.stock : "Loading..."}
                          </p>

                          <div className="d-flex justify-content-center gap-2 mt-3">
                            <button
                              className="btn btn-success"
                              onClick={() => handleAddToCart(product.id, product.stock)}
                              disabled={loading || product.stock === 0}
                            >
                              <i className="fa fa-shopping-cart me-1"></i>
                              {loading ? "Adding..." : product.stock === 0 ? "Out of Stock" : "Add To Cart"}
                            </button>
                            {product.ebay_link ? (
                              <a href={product.ebay_link} target="_blank" rel="noopener noreferrer" className="btn btn-warning">
                                <i className="fa fa-external-link me-1"></i> Buy from eBay
                              </a>
                            ) : (
                              <button className="btn btn-secondary" disabled>
                                <i className="fa fa-external-link me-1"></i> Not Available
                              </button>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="col-12 text-center">
                    <p>Loading additional products...</p>
                  </div>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-5">
            <div className="qual_1r clearfix">
              <div className="qual_1r1 clearfix text-center">
                <h2 className="text-white">Best Product Deals</h2>
                <p className="mt-3 text-light">
                  Irfan Electricals provides quality electrical products and reliable services.                </p>
                <h6 className="mb-0 mt-3 text-uppercase">
                  <Link className="button" to="/shop">Shop Now</Link>
                </h6>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ✅ Add ToastContainer for notifications */}
      <ToastContainer position="top-right" autoClose={3000} hideProgressBar />
    </section>
  );
};

export default AdditionalProduct;
